import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import CircularProgress from '@material-ui/core/CircularProgress'
import getConfig from '../../Helpers/getConfig'

import setLastPage from '../../actions/setLastPage'
import ProductCard from '../ProductCard'
import addOneToCart from '../../actions/addOneToCart'
import addToCart from '../../actions/addToCart'

import ProductsQuantityMobile from '../ProductsQuantityMobile'
import FilterAndOrder from '../FilterAndOrder'
import ProductsQuantityAndOrderDesktop from '../ProductsQuantityAndOrderDesktop'
import './index.css'
import { sendSimpleEvent } from '../../common/GoogleTagManager'
import texts from '../../common/texts.json'
import { processFacets } from './index.utils'
import CustomRefinementList from '../../functional-components/CustomRefinementList'
import BannerLiderPLP_PDP from '../../components/BannerLiderPLP_PDP'
import constants from '../../common/constants'

const optionsHitPerPage = [
  { value: 16, label: 16 },
  { value: 24, label: 24 },
  { value: 32, label: 32 },
  { value: 50, label: 50 },
  { value: 100, label: 100 },
]
const optionsSortBy = [
  { label: 'Destacados', value: '' },
  { label: 'Menor precio', value: 'price_asc' },
  { label: 'Mayor precio', value: 'price_desc' },
]

const getOptionsHitPerPage = (productsFound) => {
  const filteredOptions = optionsHitPerPage.filter((item) => item.value < productsFound)
  if (productsFound < 100) {
    filteredOptions.push({ value: productsFound, label: productsFound })
  }
  return filteredOptions
}

export const CustomClear = ({ clickHandler }) => {
  sendSimpleEvent('optimize.activate')
  return (
    <button type="button" id="clearRefinements" onClick={clickHandler} disabled={false} className="">
      {texts.FILTER.CLEAR_FILTERS}
    </button>
  )
}

class ProductsList extends Component {
  constructor(props) {
    super(props)
    this.state = { filtersMobileExpanded: false }
  }

  renderLoader = () => (
    <div className="product-list__pre-loader">
      <CircularProgress
        className="progress-primary"
        size={48}
        mode="determinate"
        value={75}
        style={{ color: '#ffc220' }}
      />
    </div>
  )

  setFacets = (facet) => {
    const { handleFacetClick } = this.props
    handleFacetClick([facet])
  }

  render() {
    const {
      name,
      facets,
      priceRange,
      facetsWhiteList,
      searchResult,
      searchState,
      nbPages,
      loading,
      handleSortBy,
      handleFacetClick,
      handleFilterClick,
      handlePageClick,
      children,
      origin,
      isMobile,
      nbHits,
      setHitsPerPage,
      isTablet,
      flowType,
      dtSearchEngine,
      shouldRenderVariants,
      bannerLiderBCI,
    } = this.props

    const sortByFilter = searchState.sortBy || ''
    const comesFromSearchPage = origin === 'Search'
    const hitsPerPage = searchState.hitsPerPage ? searchState.hitsPerPage : 16

    let facetsWithPrice = facets
    let includeUnSortableFilters = false

    if (Object.keys(priceRange).length > 0) {
      facetsWithPrice = { ...facets, [constants.FILTERS.PRICE]: priceRange }
      includeUnSortableFilters = true
    }

    const parsedFacets = processFacets(facetsWithPrice, facetsWhiteList, comesFromSearchPage, includeUnSortableFilters)
    const isMobileOrTablet = isMobile || isTablet

    const selectedValueFacets =
      searchState.minPrice && searchState.maxPrice ? { min: searchState.minPrice, max: searchState.maxPrice } : {}

    const selectedItemFacets = searchState.refinementList ? searchState.refinementList : {}

    const hitTooltip = searchResult?.find((hit) => hit.wfsEligible)

    return (
      <div className="shop-wrapper">
        {isMobileOrTablet && !loading && (
          <section className="products-list__facets-wrapper">
            <h2 className="products-list__facets-wrapper__title">{name}</h2>
            <ProductsQuantityMobile
              productsFound={nbHits}
              hitsPerPage={hitsPerPage}
              setHitsPerPage={setHitsPerPage}
              optionsHitPerPage={getOptionsHitPerPage(nbHits).map((option) => option.value)}
            />
            <FilterAndOrder
              parsedFacets={parsedFacets}
              searchState={searchState}
              handleFacetClick={handleFacetClick}
              handleFilterClick={handleFilterClick}
              handleSortBy={handleSortBy}
              isMobile={isMobileOrTablet}
              optionsSortBy={optionsSortBy}
            />
          </section>
        )}
        <div className="d-flex">
          {!isMobileOrTablet && (
            <div className=" col-lg-3 col-md-4 d-none d-md-block" data-testid="product-list-facets">
              {children}
              {parsedFacets &&
                parsedFacets.map((facet) => (
                  <CustomRefinementList
                    key={`desktop-facet-${facet.name}`}
                    selectedFacets={selectedItemFacets}
                    selectedValues={selectedValueFacets}
                    handleFacetClick={this.setFacets}
                    handleFilterClick={handleFilterClick}
                    name={facet.name}
                    items={facet.items}
                    facetId={facet.id}
                    values={facet.values}
                    sortable={facet.sortable}
                  />
                ))}
            </div>
          )}
          <div className="col-lg-9 col-md-8 bs__product-list__container">
            {!isMobileOrTablet && !loading && (
              <ProductsQuantityAndOrderDesktop
                productsFound={nbHits}
                hitsPerPage={hitsPerPage}
                setHitsPerPage={setHitsPerPage}
                optionsHitPerPage={getOptionsHitPerPage(nbHits)}
                optionsSortBy={optionsSortBy}
                sortByDefault={sortByFilter}
                sortByHandler={handleSortBy}
                productsDisplayed={searchResult.length}
                page={searchState.page || 1}
              />
            )}
            <div className="shop-content">
              <BannerLiderPLP_PDP
                className={'banner-lider-bci-plp__container'}
                isMobile={isMobile}
                liderBCI={bannerLiderBCI}
                configData={getConfig()}
              />
              {loading ? (
                this.renderLoader()
              ) : (
                <Fragment>
                  <div className="ais-Hits" data-testid="product-list-testid">
                    <ul className="ais-Hits-list">
                      {searchResult &&
                        searchResult.map((hit, ix) => (
                          <li key={`li-${ix}`} className="ais-Hits-item">
                            <ProductCard
                              hit={hit}
                              index={ix + 1}
                              origin={origin}
                              flowType={flowType}
                              searchState={searchState}
                              dtSearchEngine={dtSearchEngine}
                              shouldRenderVariants={shouldRenderVariants}
                              showWfsTooltip={hit.sku === hitTooltip?.sku}
                              isMobile={isMobileOrTablet}
                            />
                          </li>
                        ))}
                    </ul>
                  </div>
                  <div className="pagination-container">
                    <div className="pagination-wmt" data-testid="product-list-pagination">
                      <ReactPaginate
                        forcePage={Number.isNaN(searchState.page) ? 0 : searchState.page - 1}
                        previousLabel="<"
                        nextLabel=">"
                        disabledClassName="pagination-disabled-arrows"
                        breakLabel="..."
                        pageCount={nbPages}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName="ais-Pagination-list"
                        pageClassName="ais-Pagination-item ais-Pagination-item--page"
                        subContainerClassName="pages pagination"
                        activeClassName="ais-Pagination-item--selected"
                        pageLinkClassName="ais-Pagination-link"
                        previousClassName="ais-Pagination-item ais-Pagination-item--previousPage"
                        nextClassName="ais-Pagination-item ais-Pagination-item--nextPage"
                        breakClassName="pagination-break"
                        breakLinkClassName="pagination-break-link"
                      />
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCartReducer.shoppingCart,
})

const mapDispatchToProps = (dispatch) => ({
  addToCart: (item) => dispatch(addToCart(item)),
  addOneToCart: (item) => dispatch(addOneToCart(item)),
  setLastPage: (page) => dispatch(setLastPage(page)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductsList)

ProductsList.defaultProps = {
  facets: {},
  priceRange: {},
  searchResult: [],
  searchState: {},
  nbPages: 1,
  loading: true,
  handleSortBy: () => {},
  handleFacetClick: () => {},
  handlePageClick: () => {},
  children: undefined,
  facetsWhiteList: [],
  setHitsPerPage: () => {},
  name: '',
  origin: '',
  isMobile: false,
  isTablet: false,
  nbHits: 0,
  flowType: '',
  dtSearchEngine: '',
  shouldRenderVariants: false,
  bannerLiderBCI: {},
}
ProductsList.propTypes = {
  bannerLiderBCI: PropTypes.object,
  facets: PropTypes.object,
  priceRange: PropTypes.object,
  searchResult: PropTypes.array,
  searchState: PropTypes.object,
  nbPages: PropTypes.number,
  loading: PropTypes.bool,
  handleSortBy: PropTypes.func,
  setHitsPerPage: PropTypes.func,
  handleFacetClick: PropTypes.func,
  handleFilterClick: PropTypes.func,
  handlePageClick: PropTypes.func,
  children: PropTypes.node,
  facetsWhiteList: PropTypes.array,
  name: PropTypes.string,
  origin: PropTypes.string,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  nbHits: PropTypes.number,
  flowType: PropTypes.string,
  shouldRenderVariants: PropTypes.bool,
  dtSearchEngine: PropTypes.string,
}
CustomClear.defaultProps = {
  clickHandler: () => {},
}
CustomClear.propTypes = {
  clickHandler: PropTypes.func,
}
